module.exports = __webpack_public_path__ + "img/winerackdog02.bb8a0f07.jpg";